import { observer } from "mobx-react";
import React, { Component } from "react";
import logo from "../../assets/images/bocconi-logo-neg@3x.png";
import { MainStore } from "../../stores/MainStore";
import Image from "../Image";
import AdminButton from '../AdminButton';

import Label from "../Label";
import classes from "./styles.module.scss";

interface IProps {
  store: MainStore;
  title?: string;
  subtitle?: string;
}
interface IState { }
@observer
class Header extends Component<IProps, IState> {
  render() {
    const { store, title, subtitle } = this.props;
    return (
      <div className={classes.Header}>
        <div
          className={classes.HeaderSectionLeft}
          onClick={e => {
            store.backHome();
          }}
        >
          <Image src={logo} big alt="Bocconi Logo" />
        </div>
        <div className={classes.HeaderSectionCenter}>
          <Label big bold right id={title || "homepage.title"} />
          {subtitle && <Label small bold id={subtitle} />}
          <div className={classes.AdminButtonContainer} >
            <AdminButton />
          </div>
        </div>
      </div>

    );
  }
}
export default Header;
